import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.958 5H8.024l-3.962 6.99L8.035 19h7.891l4.011-7.01L15.957 5zm5.836 6.209a1.584 1.584 0 010 1.562l-4.255 7.438a1.54 1.54 0 01-1.333.791H7.755c-.53 0-1.06-.317-1.334-.791L2.206 12.77a1.586 1.586 0 010-1.562L6.42 3.77A1.563 1.563 0 017.755 3h8.47c.53 0 1.06.316 1.334.771l4.235 7.438zM14 8h2l-2 4 2 4h-2l-2-4 2-4zm-4 0l2 4-2 4H8l2-4-2-4h2z"
    />
  </svg>
);
